import React from "react"
import PropTypes from "prop-types"
import CardMedia from "@mui/material/CardMedia"
import AudioTrack from "@mui/icons-material/Audiotrack"
import styled from "styled-components"

import Caption from "./caption"

const AudioTrackWrapperOuter = styled.div`
    width: 100%;
    align-items: center;
    margin-top: 2rem;
    @media screen and (min-width: 60em) {
        display: flex;
        padding-bottom: 2rem;
    }
`

const AudioTrackWrapperInner = styled.div`
    display: none;
    float: left;
    @media screen and (min-width: 60em) {
        display: block;
    }
`
const CardMediaWrapper = styled.div`
    width: 100%;
    @media screen and (min-width: 60em) {
        width: 60%;
    }
    @media screen and (min-width: 30em) {
        padding-right: 2rem;
        padding-bottom: 20px;
    }
`

const AudioClip = ({ src, caption }) => {
    return (
        <AudioTrackWrapperOuter>
            <AudioTrackWrapperInner>
                <AudioTrack style={{ width: "3em" }} />
            </AudioTrackWrapperInner>
            <CardMediaWrapper>
                <CardMedia component="audio" src={src} controls />
            </CardMediaWrapper>
            <Caption captionRight text={caption} />
        </AudioTrackWrapperOuter>
    )
}

AudioClip.propTypes = {
    src: PropTypes.string.isRequired,
    caption: PropTypes.string,
}

export default AudioClip
